export const styles = {
  position: "relative",
  margin: "20px 0",
};

export const styles1 = {
  position: "absolute",
  bottom: 0,
  width: "100%",
  padding: "0 1em",
};

export const stylesicon = {
  color: "white",
  position: "absolute",
  top: "8px",
  right: "8px",
  cursor: "pointer",
};

export const stylesiconred = {
  color: "#c02e26",
  position: "absolute",
  top: "8px",
  right: "8px",
  cursor: "pointer",
};
export const stylediv = {
  display: "table",
  margin: "auto",
};
